import React from "react";

export function PageHeader({ title, subtitle, children, eyebrow }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6 fade-up">
      <div>
        {eyebrow && <div className="label-caps mb-2">{eyebrow}</div>}
        <h1 className="font-head text-2xl md:text-3xl font-semibold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-[#9a9a9a] mt-1.5 max-w-2xl">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2 shrink-0">{children}</div>}
    </div>
  );
}

export function PageContainer({ children }) {
  return <div className="w-full max-w-screen-2xl mx-auto p-4 md:p-6 lg:p-8">{children}</div>;
}
